
import { useNavigation } from '@react-navigation/native';
import { APIData } from '../constants';
import useRest from './base/useRest';

// CONTACTS

const preffix = "countries";

export const useCountry = (options?: APIData) => {
    return useRest(`${preffix}/`, options);
};